import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {ServiceMetrics} from 'sections/services-marketplace/experts/components';
import {Money} from 'sections/types';
import {ServiceCardContainer} from '../card-container';

interface OwnProps {
  serviceHandle: string;
  label: string;
  link: string;
  startingPrice?: Money;
  totalJobsCompleted?: number;
  averageRating?: number;
  totalReviews?: number;
}

type CombinedProps = OwnProps & WithI18nProps;

function ServiceListingCard({
  serviceHandle,
  label,
  totalJobsCompleted,
  averageRating,
  totalReviews,
  startingPrice,
  link,
}: CombinedProps) {
  return (
    <ServiceCardContainer
      serviceHandle={serviceHandle}
      label={label}
      link={link}
    >
      <ServiceMetrics
        price={startingPrice}
        jobsCompleted={totalJobsCompleted}
        overallRating={averageRating}
        totalReviews={totalReviews}
        variation="ServiceListingCard"
      />
    </ServiceCardContainer>
  );
}

export default withI18n()(ServiceListingCard);
